<div class="form-wrapper">
  <div class="box box-background has-text-centered">

    <div class="logo-container mb-5">
      <div class="logo-content">
        <img class="logo is-bordered logo-style logo-hover-pointer" width="250px" alt="Logo" src="assets/logos/symbol3.svg" (click)="goToLogin()"/>
      </div>
    </div>

    <h3 class="title is-4 mb-4">{{ 'password-recovery-confirmation.title' | translate }}</h3>
    <p class="mb-5">{{ 'password-recovery-confirmation.message' | translate }}</p>

    <button type="button" class="button is-primary is-fullwidth mb-4" (click)="goToLogin()">
      {{ 'password-recovery-confirmation.back-to-login' | translate }}
    </button>

  </div>
</div>
